<template>
    <div
        class="icon-btn-root noselect"
        :class="{
            'primary-color': color === 'primary',
            'secondary-color': color === 'secondary',
            disabled: disabled,
        }"
        @click="handleClick"
    >
        <BaseIcon :name="name" :size="size" />
    </div>
</template>

<script>
export default {
    name: 'IconBtn',
    props: {
        name: {
            type: [String, Array],
            required: true,
        },
        size: {
            type: String,
            default: undefined,
        },
        color: {
            type: String,
            default: 'primary',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        handleClick() {
            if (this.disabled) {
                return;
            }

            this.$emit('click');
        },
    },
};
</script>

<style scoped>
.icon-btn-root {
    display: flex;
    align-items: center;
    padding: 4px;
    border-radius: 50%;

    cursor: pointer;
}

.disabled {
    cursor: not-allowed !important;
}

.icon-btn-root:hover {
    background-color: rgba(0, 0, 0, 0.03);
}

.icon-btn-root:active:not(.disabled) {
    background-color: rgba(0, 0, 0, 0.06);
}
</style>
